import { Record, List } from 'immutable';
import _ from 'lodash';

export const defaultApiValues = {
  designId: null,
  width: 0,
  height: 0,
  isBleedEnabled: false,
  pageId: null,
  pageOrdinal: 0,
};

// object dto with api
const CustomSizeDto = Record({ ...defaultApiValues });

/**
 * map list of objects which represents custom-size records into CustomSizeDto records
 * @param {Array} customSize list of objects which represents custom-size records
 * @returns list of records of CustomSizeDto records
 */
export const mapToRecords = rawObjects => {
  let customSizes = new List();
  let record;

  if (_.isEmpty(rawObjects)) {
    return customSizes;
  }

  for (record of rawObjects) {
    if (!_.isEmpty(record)) {
      customSizes = customSizes.push(new CustomSizeDto(record));
    }
  }
  return customSizes;
};

/**
 * Set page ordinals taken from the design page records
 * @param {Array} customSizes List of Objects
 * @param {List} designPages List of DesignPage records
 * @returns List of customSize objects
 */
export const setPageOrdinals = (customSizes, designPages) => {
  const dataWithOrdinals = [];
  let data;

  if (_.isEmpty(customSizes) || !List.isList(designPages) || (customSizes.length !== designPages.size)) {
    return customSizes;
  }

  for (data of customSizes) {
    if (_.isEmpty(data) || !data.pageId) {
      continue;
    }

    const designPage = designPages.find(page => page.get('id') == data.pageId);
    if (_.isEmpty(designPage)) {
      continue;
    }

    dataWithOrdinals.push({
      ...data,
      pageOrdinal: designPage.get('ordinal'),
    });
  }

  return dataWithOrdinals;
}

export default CustomSizeDto;
